import { render, staticRenderFns } from "./myAvatar.vue?vue&type=template&id=24896199&scoped=true&"
import script from "./myAvatar.vue?vue&type=script&lang=js&"
export * from "./myAvatar.vue?vue&type=script&lang=js&"
import style0 from "./myAvatar.vue?vue&type=style&index=0&id=24896199&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24896199",
  null
  
)

export default component.exports